// extracted by mini-css-extract-plugin
export var billingAddress = "_rp-g";
export var contactInfo = "_rp-d";
export var customerInfoContainer = "_rp-c";
export var customerInfoContainerMobile = "_rp-h";
export var customerInfoRow = "_rp-a";
export var customerInfoSection = "_rp-b";
export var fullWidthDividerMobile = "_rp-i";
export var imageContainer = "_rp-1";
export var paymentMethod = "_rp-e";
export var priceText = "_rp-6";
export var priceTextMobile = "_rp-7";
export var product = "_rp-0";
export var productImage = "_rp-2";
export var productInfo = "_rp-4";
export var productMobile = "_rp-9";
export var productTitle = "_rp-8";
export var quantityBadge = "_rp-3";
export var quantityText = "_rp-5";
export var shippingAddress = "_rp-f";